// extracted by mini-css-extract-plugin
export var noSpinners = "_nu-6";
export var percentageInput = "_nu-7";
export var variantColor1 = "_nu-0";
export var variantColor2 = "_nu-1";
export var variantColor3 = "_nu-2";
export var variantColor4 = "_nu-3";
export var variantColor5 = "_nu-4";
export var variantColor6 = "_nu-5";